export default {
  data() {
    return {
      config: JSON.parse(localStorage.getItem("config")),
      formInfo: {},
      type: 0,
      action: 0,

      formSet: {},
      form: {
        type: 2,
      },
      dateDay: [
        {
          title: "上午",
          key: "am",
        },
        {
          title: "下午",
          key: "pm",
        },
      ],

      flow: {},
      targetList: [],
      mark: "",
      showImage: false,
      path: "",
      loading:false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },

  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },

    serId: {
      type: Number,
      default() {
        return 0;
      },
    },
    formId: {
      type: String,
      default() {
        return "";
      },
    },
  },

  created() {
    this.getForm();
    this.getSet();
  },
  methods: {
    getData() {
      var self = this;
      this.$axios({
        baseURL: this.config.OA,
        url: `form/info/dataAndFlow/${this.serId}`,
        method: "GET",
      }).then((res) => {
        if (res.code == 200) {
          var data = res.data;
          if (data == null) {
            return;
          }

          var form = data;

          var uploadIds = [];
          form.formList.forEach((a, index) => {
            if (a.set.control == "upload") {
              if (a.set.uploadId && a.set.uploadId.length > 0) {
                uploadIds.push({
                  setId: a.set.setId,
                  uploadId: a.set.uploadId,
                });
              } else {
                a.set.uploadFiles = {
                  id: "",
                  files: [],
                };
              }
            }
          });

          if (uploadIds.length > 0) {
            this.getUploadInfo(uploadIds);
          }

          //获取第一个需要办理的流程
          var flows = form.flows.filter((a) => {
            return (
              a.status == 2 &&
              a.users.filter((c) => {
                return (
                  c.nodeId == self.user.uid &&
                  c.type == self.user.type &&
                  c.action == 0
                );
              }).length > 0
            );
          });

          if (flows && flows.length > 0) {
            this.flow = flows[0];
          }
          console.log(`flow:${JSON.stringify(this.flow)}`);
          this.formInfo = form;
        }
      });
    },

    selectObj(model, data, list) {
      var self = this;
      console.log(
        `model:${JSON.stringify(model)},data:${JSON.stringify(
          data
        )},list:${JSON.stringify(list)}`
      );
      // {"title":"叶春蕾","nodeId":"6d42ce6656364a828d2d7b9eb32802d5","type":"teacher"}
      var list = data[1].map((a) => {
        return {
          title: a.name,
          type: a.type,
          nodeId: a.uid,
          schId: self.user.schId,
          action: 0,
          mark: "",
          isSelfSelect: true,
        };
      });

      model.users = model.users.concat(list);

      this.targetList = [];
    },
    removeUser(index, i, model) {
      console.log(JSON.stringify(model));
      model.users.splice(index, 1);
      this.formInfo.flows.splice(i, 1, model);
    },

    preFile(file) {
      // this.$tools.preFile(path);
      // this.downloadFile(file.fullPath, file.name);
      window.open(file.fullPath + "?attname=" + file.name);
    },
    downloadFile(url, filename) {
      this.$axios
        .get(url, {
          responseType: "blob",
        })
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          }); // 构造一个blob对象来处理数据，并设置文件类型
          if (window.navigator.msSaveOrOpenBlob) {
            // 兼容IE10
            navigator.msSaveBlob(blob, filename);
          } else {
            const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
            const a = document.createElement("a");
            a.style.display = "none";
            a.href = href; // 指定下载链接
            a.download = filename; // 指定下载文件名
            a.click();
            URL.revokeObjectURL(a.href); // 释放URL对象
          }
        });
    },
    getFileIcon(path) {
      let num = path.lastIndexOf("/") + 1;
      let name = path.substring(num);
      var fileExtension = name
        .substring(name.lastIndexOf(".") + 1)
        .toLocaleLowerCase();

      var icon = "file.png";
      switch (fileExtension) {
        case "png":
        case "jpeg":
        case "jpg":
          icon = "tupian.png";
          break;
        case "doc":
        case "docx":
          icon = "word.png";
          break;
        case "mp4":
        case "mov":
          icon = "music.png";
          break;
        case "pdf":
          icon = "pdf.png";
          break;
        case "ppt":
        case "pptx":
          icon = "ppt.png";
          break;
        case "txt":
          icon = "txt.png";
          break;
        case "xls":
        case "xlsx":
          icon = "excel.png";
          break;
        case "rar":
        case "zip":
          icon = "yasuobao.png";
          break;
      }

      return "https://www.rayscloud.cn/tyrz/file/" + icon;
    },
    getUploadInfo(uploadIds) {
      var self = this;
      uploadIds.forEach((a) => {
        self
          .$axios({
            baseURL: this.config.OA,
            url: `upload/${a.uploadId}`,
            method: "GET",
          })
          .then((res) => {
            if (res.code == 200) {
              var setId = a.setId;
              var formInfo = Object.assign({}, self.formInfo);
              var formList = formInfo.formList.filter((a) => {
                return a.set.setId == setId;
              });
              if (formList && formList.length > 0) {
                var model = formList[0];
                model.set.uploadFiles = res.data;
                var index = formInfo.formList.indexOf(model);
                formInfo.formList.splice(index, 1, model);
              }

              this.formInfo = formInfo;
            }
          });
      });
    },
    getForm() {
      this.$axios({
        baseURL: this.config.OA,
        url: `form/info/id/${this.formId}`,
        method: "GET",
      }).then((res) => {
        if (res.code == 200) {
          this.form = res.data;
        }
      });
    },
    formatterFlow(status, actions, flowType, users) {
      if (status == 1 && actions != 0 && flowType == 1) {
        var list = [];
        users.forEach((a) => {
          if (a.action == 1 || a.action == 2) {
            //操作过的
            list.push(a);
          }
        });

        return list;
      }
      return users;
    },

    getSet() {
      this.$axios({
        baseURL: this.config.OA,
        BaseUrl: process.env.VUE_APP_OA,
        url: `form/info/set/${this.formId}`,
        method: "GET",
      }).then((res) => {
        if (res.code == 200) {
          this.formSet = res.data;
          this.getData();
        }
      });
    },
    preImage(image) {
      this.path = image;
      this.showImage = true;
    },
    getFlowType(status, action) {
      // [Description("流程状态：1、已经完成，2、等待完成（待审核）")]
      //         public int status { get; set; }

      //         /// <summary>
      //         /// 流程操作信息：0、待处理，1、同意，2、拒绝
      //         /// </summary>
      //         [Description("流程操作信息：0、待处理，1、同意，2、拒绝")]
      //         public int actoins { get; set; }
      // https://www.rayscloud.cn/oa/tag/ty_icon.png
      // 1、 同意/通过/完成 ty_icon，2、待处理 dsh_icon，3、拒绝 jj_icon
      var icon = "";
      if (status == 1) {
        switch (action) {
          case 1:
            icon = "ty_icon.png";
            break;
          case 2:
            icon = "jj_icon.png";
            break;
          default:
            icon = "ty_icon.png";
            break;
        }
      } else {
        icon = "dsh_icon.png";
      }
      return `https://www.rayscloud.cn/oa/tag/${icon}`;
    },

    exam(action) {
      if (!this.loading) {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 30 * 1000);
      }else {
        return;
      }
      this.$axios
        .request({
          baseURL: this.config.OA,
          url: `form/info/data/exam/${this.serId}`,
          method: "PUT",
          data: {
            flowSerId: this.flow.serId,
            action: action,
            mark: this.mark,
            flow: this.flow,
            flows: this.formInfo.flows,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            this.$emit("ok", "");
          } else {
            this.$Message.error(res.msg);
          }
        });
    },

    currentDate(fmt) {
      //author: meizz
      var date = new Date();
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    },

    getInfo(model) {
      if (!model.value) return " ";
      var value = JSON.parse(model.value);
      switch (model.control) {
        case "hq_wz": 
        case "wz_sq":{
          var title = "";
          value.forEach((a) => {
            title += `物品：${a.title},申请数量：${a.count}\n`;
          });

          return title;
        }
        case "input":
        case "radio":
          return value;
        case "class_stu":
        case "xb_grade":
        case "xb_sub":
          return value.title;
        case "xb_teacher":
          return value.title;
        case "xb_place":
          return value.title;
        case "user_baseinfo": {
          var title = value.name;
          if (value.type == "student") {
            title += `/${value.className}`;
          }
          return title;
        }
        case "school_week": {
          return value.title;
        }
        case "upload": {
          if (model.type == "file") {
            var files = model.uploadFiles.files.map((a) => {
              return {
                name: a.o.name,
                fullPath: a.o.fullPath,
                path: a.o.path,
              };
            });

            return files;
          } else {
            return value;
          }
        }
        case "xb_editor": {
          value = this.imgTagAddStyle(value);
          console.log(`富文本：${value}`);
          return value;
        }

        default:
          return value;
      }
    },
    imgTagAddStyle(htmlstr) {
      if (htmlstr == null || htmlstr == undefined || htmlstr.length == 0) {
        return "<p></p>";
      }
      //正则匹配所有img标签
      //var regex0 = new RegExp("(i?)(\<img)([^\>]+\>)","gmi");
      //正则匹配不含style="" 或 style='' 的img标签
      var regex1 = new RegExp(
        "(i?)(<img)(?!(.*?style=['\"](.*)['\"])[^>]+>)",
        "gmi"
      );
      //给不含style="" 或 style='' 的img标签加上style=""
      htmlstr = htmlstr.replace(regex1, '$2 style=""$3');

      //正则匹配含有style的img标签
      var regex2 = new RegExp("(i?)(<img.*?style=['\"])([^>]+>)", "gmi");
      //在img标签的style里面增加css样式(这里增加的样式：display:block;max-width:100%;height:auto;border:5px solid red;)
      htmlstr = htmlstr.replace(
        regex2,
        "$2display:block;max-width:100%;height:auto;$3"
      );

      return htmlstr;
    },
    getIcon(status, action) {
      var icon = "";
      if (status == 0) {
        switch (action) {
          case 1:
            icon = "sh_l.png";
            break;
          case 4:
            icon = "bl_l.png";
            break;
          default:
            icon = "wc_l.png";
            break;
        }
      } else {
        switch (action) {
          case 2:
            icon = "tg_l.png";
            break;
          case 3:
            icon = "jj_l.png";
            break;
          case 6:
            icon = "jj_l.png";
            break;
          default:
            icon = "wc_l.png";
            break;
        }
      }
      return `https://www.rayscloud.cn/oa/tag/${icon}`;
    },

    dateFormatter(time) {
      time = time.replace(/-/g, "/");

      var timestamp = new Date(time).getTime();

      var minute = 1000 * 60;
      var hour = minute * 60;
      var day = hour * 24;
      var halfamonth = day * 15;
      var month = day * 30;
      var year = day * 365;
      var now = new Date().getTime();
      var diffValue = now - timestamp;
      var result;
      if (diffValue < 0) {
        return;
      }
      var yearC = diffValue / year;
      var monthC = diffValue / month;
      var weekC = diffValue / (7 * day);
      var dayC = diffValue / day;
      var hourC = diffValue / hour;
      var minC = diffValue / minute;
      if (yearC >= 1) {
        result = this.dateFtt(time, "yyyy-MM-dd hh:mm");
      } else if (monthC >= 1) {
        result = this.dateFtt(time, "MM-dd hh:mm");
      } else if (weekC >= 1) {
        result = this.dateFtt(time, "MM-dd hh:mm");
      } else if (dayC >= 1) {
        result = this.dateFtt(time, "MM-dd hh:mm");
      } else if (hourC >= 1) {
        result = this.dateFtt(time, "MM-dd hh:mm");
      } else if (minC >= 1) {
        result = "" + parseInt(minC) + "分钟前";
      } else result = "刚刚";
      return result;
    },
    dateFtt(time, fmt) {
      //author: meizz
      var date = new Date(time);
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    },
  },
};
